// EXTERNAL DEPENDENCIES
import React from 'react'

// COMPONENTS
import { Row } from '@paypalcorp/pp-react'
import LoadingShimmer from '../loading-shimmer'

// CONSTANTS
import { WITH_LOADING_SHIMMER_ROW_CONTAINER_TEST_ID } from '../../../../constants/test-ids'

// STYLES
import styles from './styles.module.less'

// TYPES
import { ShimmeringComponent } from '../types'

/**
 * Shows a default of 1 shimmering body element while isLoading is true
 * @param isLoading
 * @param children
 */
export function WithLoadingShimmer({
  isLoading,
  children,
  ShimmeringComponent,
  withSeparation,
  numberOfShimmers = 1,
}: {
  isLoading: boolean
  children: React.ReactElement
  ShimmeringComponent?: ShimmeringComponent
  withSeparation?: boolean
  numberOfShimmers?: number
}) {
  const shimmers = [...Array(numberOfShimmers)].map((_el, idx) => (
    <LoadingShimmer key={idx + 1} ShimmeringComponent={ShimmeringComponent} />
  ))

  const className = `${styles.loadingShimmerContainer}${
    withSeparation ? ` ${styles.withMargin}` : ''
  }`

  return isLoading ? (
    <Row
      className={className}
      data-testid={WITH_LOADING_SHIMMER_ROW_CONTAINER_TEST_ID}
    >
      {shimmers}
    </Row>
  ) : (
    children
  )
}
